var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('pull-refresh',{attrs:{"refresh":_vm.refresh}},[_c('v-card',{attrs:{"tile":""}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.group.name)+" ")]),(_vm.loading)?_c('circular-loader'):_vm._e(),(!_vm.loading)?_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.group.description))]),_c('under-construction')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }